import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Tournament } from '@mtgame/core';
import { getTeamPageRoute, getTournamentRoute } from '@config/routes';

@Component({
  selector: 'mtg-tournament-standings',
  templateUrl: './tournament-standings.component.html',
  styleUrls: ['../shared/styles.scss', './tournament-standings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentStandingsComponent {
  @Input()
  tournament: Tournament;

  getTournamentRoute(): string[] {
    return getTournamentRoute(this.tournament.alias);
  }

  getTeamRoute(teamId: number): string[] {
    return getTeamPageRoute(teamId);
  }
}
